import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// This entry point handles Admin and Creditor views only.
// Client and Calculator have their own independent entry points:
//   - Client:     src/index.client.js     (webpack.client.config.js)
//   - Calculator:  src/index.calculator.js  (webpack.calculator.config.js)
const view = process.env.REACT_APP_VIEW || 'admin';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App view={view} />
  </React.StrictMode>
);

